import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {BillingRunDto} from "./billing-run.dto";
import {CustomerPaymentPlannedTypeDto} from "./customer-payment-planned-type.dto";
import {PlannedPaymentStatus} from "../../../enum/planned-payment-status.enum";

export class CustomerPaymentPlannedDto extends DtoDetail{

    public billingRunDto? : BillingRunDto;
    public billingRunDtoId : number;
    public billingRunDtoName : string;
    public customerDtoId : number;
    public customerDtoName : string;
    public plannedTypeDto? : CustomerPaymentPlannedTypeDto;
    public plannedTypeDtoId : number;
    public plannedTypeDtoName : string;
    public paymentStatus: PlannedPaymentStatus;
    public amount: number;
    public remainingAmount: number;
    public currency: string;

}
